module.exports = __webpack_public_path__ + "img/login.3780d275.jpg";